import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'sonner';
import {
  FolderOpen, MessageSquare, Network, GraduationCap, FileCheck,
  BookOpen, Fingerprint, ClipboardList, ShieldCheck, LayoutDashboard,
  Shield, IdCard, Siren, Users, UserCog, ArrowRight, Sparkles,
  CheckCircle2, Lock, ExternalLink, Phone, Mail, Briefcase, X, UserCircle,
  Smartphone, Apple, Download, AlertCircle,
} from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const SGES_URL = 'https://www.sges.cl/';
const ACRED_LABORAL_URL = 'https://lomasbayas.acreditacionsercol.cl';

// Catalogo de modulos TYSTA CORE
const MODULES = [
  { id: 1, name: 'Carpeta de Arranque', icon: FolderOpen, color: '#E6A817',
    desc: 'Acreditacion de Carpetas de Arranque y Extensiones de Servicio.',
    externalUrl: 'https://arranque.tysta.cl/', category: 'acreditacion',
    areaResponsable: 'Superintendencia HS',
    contactos: [
      { nombre: 'Natalia Contreras', telefono: '+56 9 4020 8947', email: 'Natalia.Contreras@glencore.cl' },
      { nombre: 'Antonella Mella', telefono: '+56 9 6518 6217', email: 'Antonella.Mella@glencore.cl' },
    ],
  },
  { id: 'sges', name: 'SGES', icon: Shield, color: '#0F766E',
    desc: 'Carta de Inicio de Actividades, ingreso E-200.',
    externalUrl: SGES_URL, category: 'acreditacion',
    areaResponsable: 'Superintendencia HS',
    contactos: [
      { nombre: 'Liviana Ratti', telefono: '+56 9 9255 0778', email: 'livania.ratti@sges.cl' },
      { nombre: 'Sergio Gonzalez', telefono: '+56 9 9543 6444', email: 'sergio.gonzalez@sges.cl' },
    ],
  },
  { id: 'acred_lab', name: 'Acreditacion Laboral', icon: IdCard, color: '#B45309',
    desc: 'Acreditacion laboral Lomas Bayas (Sercol).',
    externalUrl: ACRED_LABORAL_URL, category: 'acreditacion',
    areaResponsable: 'Gerencia Personal - Área Laboral',
    empresaResponsable: 'SERCOL',
    contactos: [
      { nombre: 'Javier Ayala', telefono: '+56 9 3370 5376', email: 'jayala@sercol.cl' },
      { nombre: 'Mario Chuy', telefono: '+56 9 3199 3414', email: 'mchuy@sercol.cl' },
      { nombre: 'Correo general', email: 'acreditacion.cmlb@sercol.cl' },
    ],
  },
  { id: 4, name: 'Inducción Lomas Bayas y Capacitaciones', icon: GraduationCap, color: '#1B919B',
    desc: 'Induccion, Curso de Conduccion y Cursos Especificos.',
    route: '/portal/dashboard', category: 'acreditacion',
    areaResponsable: 'Superintendencia HS',
    contactos: [
      { nombre: 'Natalia Contreras', telefono: '+56 9 4020 8947', email: 'Natalia.Contreras@glencore.cl' },
      { nombre: 'Antonella Mella', telefono: '+56 9 6518 6217', email: 'Antonella.Mella@glencore.cl' },
    ],
  },
  { id: 6, name: 'APP Pase Digital', icon: Fingerprint, color: '#6C3D8E',
    desc: 'Identidad laboral y de seguridad inteligente.',
    isApp: true, category: 'acreditacion' },
  { id: 12, name: 'Repositorio HS', icon: BookOpen, color: '#DB2777',
    desc: 'Estandares Lomas Bayas, Protocolos de Fatalidad.',
    externalUrl: 'https://arranque.tysta.cl/web/?pass=R2dFdERnNENLQWdESFJFK0Z3UUJCaDBQVWw0PQ==',
    category: 'acreditacion' },
  { id: 2, name: 'GCOM', icon: MessageSquare, color: '#D35400',
    desc: 'Comunicacion efectiva y trazabilidad operativa.',
    externalUrl: 'https://arranque.tysta.cl/acceso_gcom', category: 'operacion_hs' },
  { id: 3, name: 'Organigrama Corporativo', icon: Network, color: '#5B7D9A',
    desc: 'Estructura organizacional dinamica.', route: '/dashboard', category: 'operacion_hs' },
  { id: 5, name: 'Control Documental', icon: FileCheck, color: '#6B8E8E',
    desc: 'Gestion centralizada de documentos.', route: '/control-documental', category: 'operacion_hs' },
  { id: 7, name: 'Planificador HS', icon: ClipboardList, color: '#a05e49',
    desc: 'Programa Planificador HS.', route: '/liderazgo', category: 'operacion_hs' },
  { id: 8, name: 'Checklist Digital', icon: ShieldCheck, color: '#2E7D32',
    desc: 'Checklists de seguridad operacional.', route: '/herramientas-viewer', category: 'operacion_hs' },
  { id: 11, name: 'HS Safework', icon: Siren, color: '#0E7490',
    desc: 'Reportabilidad de Eventos.', isExternal: true,
    externalUrl: 'https://sglomas.sam.glencore.net/Login.aspx', category: 'operacion_hs' },
  { id: 9, name: 'Centro Integrado de Datos', icon: LayoutDashboard, color: '#7C3AED',
    desc: 'Dashboards consolidados.', route: '/centro-datos', category: 'operacion_hs' },
  { id: 13, name: 'Reporte de Incidente', icon: AlertCircle, color: '#DC2626',
    desc: 'Reporta incidentes de seguridad, salud, medio ambiente y peligros.',
    route: '/incidentes', category: 'operacion_hs' },
];

// IDs de modulos que aparecen en la linea de tiempo (no se duplican abajo)
const TIMELINE_MODULE_IDS = [4, 1, 'sges', 'acred_lab', 6];
// IDs de modulos que se ocultan del bloque "Otros Modulos Disponibles"
const HIDDEN_FROM_OTROS = [8 /* Checklist Digital */];
// IDs de modulos que SIEMPRE se muestran en "Otros Modulos Disponibles" (acceso global)
const FORCE_IN_OTROS = [11 /* HS Safework */];

export default function EsePanel() {
  const { token, user } = useAuth();
  const navigate = useNavigate();
  const headers = { Authorization: `Bearer ${token}` };
  const [enabledIds, setEnabledIds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [contactModule, setContactModule] = useState(null);
  const [showAppModal, setShowAppModal] = useState(false);

  const fetchEnabled = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/ese/mis-modulos`, { headers });
      setEnabledIds(res.data || []);
    } catch { toast.error('No se pudieron cargar los modulos'); }
    setLoading(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);
  useEffect(() => { fetchEnabled(); }, [fetchEnabled]);

  const isEnabled = (mod) => typeof mod.id === 'number' && enabledIds.includes(mod.id);
  const getModule = (id) => MODULES.find(m => m.id === id);

  const handleSelect = (mod) => {
    if (mod.externalUrl) { window.open(mod.externalUrl, '_blank'); return; }
    if (mod.isApp) { setShowAppModal(true); return; }
    if (mod.route) navigate(mod.route);
  };

  // Pasos secuenciales iniciales (setup ESE)
  const setupSteps = [
    { id: 'trabajadores', label: 'Crear Trabajadores, asignar actividades y áreas', desc: 'Registra a tu equipo y asigna sus actividades y áreas', icon: Users,
      color: '#3B82F6', onClick: () => navigate('/ese/trabajadores') },
    { id: 'usuarios', label: 'Crear Usuarios', desc: 'Cuentas de acceso al portal', icon: UserCog,
      color: '#8B5CF6', onClick: () => navigate('/ese/usuarios') },
  ];

  // Pasos en paralelo (modulos TYSTA CORE)
  // Inducción/Capacitaciones para ESE va al calendario propio (/ese/sesiones)
  const induccionMod = {
    ...getModule(4),
    route: '/ese/sesiones',
    externalUrl: undefined,
    desc: 'Inscribe a tus trabajadores en sesiones de Inducción y Conducción.',
    forceEnabled: true,
  };
  const paralelos = [
    { mod: induccionMod, tag: 'Induccion / Conduccion' },
    { mod: getModule(1), tag: 'Carpeta de Arranque' },
    { mod: getModule('sges'), tag: 'Carta de Inicio (SGES)' },
    { mod: getModule('acred_lab'), tag: 'Acreditacion Laboral' },
  ];

  const appPaseModule = getModule(6);
  const enabledTotal = MODULES.filter(isEnabled).length + 2 /* setup steps siempre disponibles */;

  // Modulos que NO estan en la linea de tiempo y SI estan habilitados
  // (ademas, los listados en FORCE_IN_OTROS siempre aparecen)
  const otrosHabilitados = MODULES.filter(m =>
    !TIMELINE_MODULE_IDS.includes(m.id) &&
    !HIDDEN_FROM_OTROS.includes(m.id) &&
    (FORCE_IN_OTROS.includes(m.id) || isEnabled(m))
  );

  return (
    <div className="space-y-5" data-testid="ese-panel-central">
      {/* Header */}
      <div className="rounded-xl px-5 py-4 text-white" style={{ background: 'linear-gradient(135deg, #208178 0%, #156055 100%)' }}>
        <div className="flex items-center justify-between flex-wrap gap-3">
          <div>
            <h1 className="text-xl font-bold">Hola, {(user?.nombre || '').split(' ')[0]}!</h1>
            <p className="text-sm text-white/85">Sigue el flujo recomendado para tener todo listo en TystaCore.</p>
          </div>
          <div className="text-right">
            <p className="text-2xl font-bold">{enabledTotal}</p>
            <p className="text-xs text-white/70 uppercase tracking-wide">Modulos disponibles</p>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="text-center text-slate-400 py-12">Cargando panel...</div>
      ) : (
        <>
          {/* Linea de tiempo */}
          <section className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm">
            <div className="flex items-center justify-between gap-2 mb-5">
              <div className="flex items-center gap-2">
                <Sparkles className="w-4 h-4 text-amber-500" />
                <h2 className="text-sm font-bold text-slate-900 uppercase tracking-wider">Flujo de Onboarding</h2>
              </div>
              <p className="text-xs text-slate-500">Cada paso te lleva al modulo correspondiente.</p>
            </div>

            {/* Setup secuencial */}
            <div className="relative">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 relative z-10">
                {setupSteps.map((step, i) => (
                  <TimelineNode
                    key={step.id}
                    number={i + 1}
                    title={step.label}
                    desc={step.desc}
                    icon={step.icon}
                    color={step.color}
                    onClick={step.onClick}
                    enabled={true}
                    showArrow={i < setupSteps.length - 1}
                    testId={`step-${step.id}`}
                  />
                ))}
              </div>
            </div>

            {/* Conector hacia paralelos */}
            <div className="flex items-center justify-center my-4">
              <div className="flex items-center gap-2">
                <div className="h-px w-16 bg-slate-300" />
                <div className="px-3 py-0.5 rounded-full bg-emerald-50 border border-emerald-200">
                  <span className="text-[10px] font-bold text-emerald-700 uppercase tracking-wide">Gestion en paralelo</span>
                </div>
                <div className="h-px w-16 bg-slate-300" />
              </div>
            </div>

            {/* Paralelos: 4 modulos */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 items-stretch">
              {paralelos.map((p, i) => (
                <div key={p.mod?.id || i} className="flex flex-col gap-2 h-full">
                  <div className="flex-1">
                    <TimelineNode
                      number={i + 3}
                      title={p.tag}
                      desc={p.mod?.desc}
                      icon={p.mod?.icon}
                      color={p.mod?.color}
                      onClick={() => p.mod && handleSelect(p.mod)}
                      enabled={p.mod ? (p.mod.forceEnabled || typeof p.mod.id !== 'number' || isEnabled(p.mod)) : false}
                      external={!!p.mod?.externalUrl}
                      testId={`step-paralelo-${p.mod?.id || i}`}
                      fullHeight
                    />
                  </div>
                  {p.mod?.contactos?.length > 0 && (
                    <button
                      type="button"
                      onClick={() => setContactModule(p.mod)}
                      data-testid={`btn-contactos-${p.mod.id}`}
                      className="flex items-center justify-center gap-1.5 text-[10px] font-semibold uppercase tracking-wide text-slate-500 hover:text-slate-900 bg-slate-50 hover:bg-slate-100 border border-slate-200 rounded-lg py-1.5 transition-colors"
                    >
                      <UserCircle className="w-3 h-3" />
                      Ver contactos
                    </button>
                  )}
                </div>
              ))}
            </div>

            {/* Conector hacia App */}
            <div className="flex items-center justify-center my-4">
              <ArrowRight className="w-4 h-4 text-slate-400 rotate-90" />
            </div>

            {/* APP Pase final */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <div className="md:col-start-2">
                <TimelineNode
                  number={7}
                  title="Listo! Descarga tu APP"
                  desc="Búscala como Credencial Digital Tysta o pincha aquí"
                  icon={appPaseModule?.icon}
                  color={appPaseModule?.color}
                  onClick={() => setShowAppModal(true)}
                  enabled={true}
                  highlight
                  testId="step-app-pase"
                />
              </div>
            </div>
          </section>

          {/* Otros modulos habilitados */}
          {otrosHabilitados.length > 0 && (
            <section>
              <div className="flex items-center gap-2 mb-3 px-1">
                <h2 className="text-sm font-bold text-slate-900 uppercase tracking-wider">Otros modulos disponibles</h2>
                <span className="text-xs text-slate-400">({otrosHabilitados.length})</span>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
                {otrosHabilitados.map(mod => (
                  <ModuleCard key={mod.id} mod={mod} onClick={() => handleSelect(mod)} />
                ))}
              </div>
            </section>
          )}
        </>
      )}

      {contactModule && (
        <ContactModal mod={contactModule} onClose={() => setContactModule(null)} />
      )}
      {showAppModal && (
        <AppDownloadModal onClose={() => setShowAppModal(false)} />
      )}
    </div>
  );
}

function TimelineNode({ number, title, desc, icon: Icon, color = '#94a3b8', onClick, enabled, showArrow, external, highlight, testId, fullHeight, compact }) {
  const padding = compact ? 'p-2.5' : 'p-4';
  const iconBox = compact ? 'w-8 h-8' : 'w-10 h-10';
  const iconSize = compact ? 'w-4 h-4' : 'w-5 h-5';
  if (!enabled) {
    return (
      <div className={`relative rounded-xl border-2 border-dashed border-slate-200 bg-slate-50/60 opacity-70 ${padding} ${fullHeight ? 'h-full' : ''}`} data-testid={testId}>
        <div className="flex items-start gap-2.5">
          <div className={`${iconBox} rounded-full bg-slate-200 flex items-center justify-center shrink-0`}>
            <Lock className="w-3.5 h-3.5 text-slate-400" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs font-semibold text-slate-500 truncate">{title}</p>
            <p className="text-[10px] text-slate-400 mt-0.5">No disponible para tu empresa</p>
          </div>
        </div>
      </div>
    );
  }
  return (
    <button onClick={onClick}
      className={`relative w-full text-left rounded-xl border-2 transition-all hover:shadow-lg hover:scale-[1.02] cursor-pointer group ${padding} ${highlight ? 'border-amber-300 bg-gradient-to-br from-amber-50 to-orange-50' : 'border-slate-200 bg-white hover:border-slate-300'} ${fullHeight ? 'h-full' : ''}`}
      data-testid={testId}
      style={highlight ? {} : { borderLeftColor: color, borderLeftWidth: '4px' }}>
      <div className="flex items-start gap-2.5">
        <div className="relative shrink-0">
          <div className={`${iconBox} rounded-full flex items-center justify-center shadow-sm`} style={{ backgroundColor: `${color}15`, border: `2px solid ${color}` }}>
            {Icon && <Icon className={iconSize} style={{ color }} strokeWidth={2.2} />}
          </div>
          <div className="absolute -top-1 -right-1 min-w-[16px] h-[16px] px-1 rounded-full bg-white border-2 flex items-center justify-center text-[9px] font-bold"
            style={{ borderColor: color, color }}>
            {number}
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1.5">
            <p className="text-xs font-semibold text-slate-900 truncate">{title}</p>
            {external && <ExternalLink className="w-3 h-3 text-slate-400 shrink-0" />}
          </div>
          <p className={`text-[10px] text-slate-500 mt-0.5 line-clamp-2 ${fullHeight ? 'min-h-[26px]' : ''}`}>{desc}</p>
        </div>
      </div>
      {showArrow && (
        <div className="hidden md:flex absolute top-1/2 -right-3 -translate-y-1/2 items-center justify-center w-6 h-6 rounded-full bg-white border border-slate-200 shadow-sm z-20">
          <ArrowRight className="w-3 h-3 text-slate-400" />
        </div>
      )}
    </button>
  );
}

function ModuleCard({ mod, onClick }) {
  const Icon = mod.icon;
  return (
    <button onClick={onClick}
      data-testid={`other-module-${mod.id}`}
      className="flex items-start gap-3 rounded-xl border-2 border-slate-200 bg-white p-3 transition-all hover:shadow-md hover:scale-[1.02] cursor-pointer text-left"
      style={{ borderLeftColor: mod.color, borderLeftWidth: '4px' }}>
      <div className="w-9 h-9 rounded-full flex items-center justify-center shrink-0" style={{ backgroundColor: `${mod.color}15`, border: `2px solid ${mod.color}` }}>
        <Icon className="w-4 h-4" style={{ color: mod.color }} strokeWidth={2.2} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-semibold text-slate-900 truncate">{mod.name}</p>
        <p className="text-[10px] text-slate-500 mt-0.5 line-clamp-2">{mod.desc}</p>
      </div>
      {mod.externalUrl && <ExternalLink className="w-3 h-3 text-slate-400 mt-1 shrink-0" />}
    </button>
  );
}


function ContactModal({ mod, onClose }) {
  const Icon = mod.icon;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm"
      onClick={onClose}
      data-testid="contact-modal-overlay"
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden"
        onClick={(e) => e.stopPropagation()}
        data-testid="contact-modal"
      >
        {/* Header */}
        <div className="flex items-start gap-3 px-5 py-4 border-b border-slate-200" style={{ borderTopColor: mod.color, borderTopWidth: '4px' }}>
          <div className="w-11 h-11 rounded-full flex items-center justify-center shrink-0" style={{ backgroundColor: `${mod.color}15`, border: `2px solid ${mod.color}` }}>
            {Icon && <Icon className="w-5 h-5" style={{ color: mod.color }} strokeWidth={2.2} />}
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-bold text-slate-900">{mod.name}</h3>
            {mod.areaResponsable && (
              <div className="flex items-center gap-1 mt-0.5">
                <Briefcase className="w-3 h-3 text-slate-400" />
                <p className="text-[11px] text-slate-500">{mod.areaResponsable}</p>
              </div>
            )}
            {mod.empresaResponsable && (
              <p className="text-[10px] text-slate-400 mt-0.5">Empresa: {mod.empresaResponsable}</p>
            )}
          </div>
          <button
            onClick={onClose}
            data-testid="contact-modal-close"
            className="w-8 h-8 rounded-full hover:bg-slate-100 flex items-center justify-center text-slate-500"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* Contactos */}
        <div className="px-5 py-4">
          <p className="text-[10px] font-bold uppercase tracking-wider text-slate-400 mb-3">Contactos</p>
          <div className="space-y-3">
            {mod.contactos?.map((c, i) => (
              <div
                key={i}
                className="rounded-lg border border-slate-200 bg-slate-50/60 p-3"
                data-testid={`contact-item-${i}`}
              >
                <div className="flex items-center gap-2 mb-1.5">
                  <div className="w-7 h-7 rounded-full bg-white border border-slate-200 flex items-center justify-center shrink-0">
                    <UserCircle className="w-4 h-4 text-slate-500" />
                  </div>
                  <p className="text-xs font-semibold text-slate-900">{c.nombre}</p>
                </div>
                <div className="space-y-1 pl-9">
                  {c.telefono && (
                    <a
                      href={`tel:${c.telefono.replace(/\s/g, '')}`}
                      className="flex items-center gap-1.5 text-[11px] text-slate-600 hover:text-slate-900"
                    >
                      <Phone className="w-3 h-3 text-slate-400" />
                      <span>{c.telefono}</span>
                    </a>
                  )}
                  {c.email && (
                    <a
                      href={`mailto:${c.email}`}
                      className="flex items-center gap-1.5 text-[11px] text-slate-600 hover:text-slate-900 break-all"
                    >
                      <Mail className="w-3 h-3 text-slate-400 shrink-0" />
                      <span>{c.email}</span>
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}


function AppDownloadModal({ onClose }) {
  const APP_STORE_URL = 'https://apps.apple.com/cl/app/credencial-digital-tysta/id6756027006';
  const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=cl.legav.pase_digital.tysta';
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm"
      onClick={onClose}
      data-testid="app-modal-overlay"
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden"
        onClick={(e) => e.stopPropagation()}
        data-testid="app-modal"
      >
        {/* Header */}
        <div className="relative px-5 py-5 bg-gradient-to-br from-amber-50 to-orange-50 border-b border-amber-200">
          <button
            onClick={onClose}
            data-testid="app-modal-close"
            className="absolute top-3 right-3 w-8 h-8 rounded-full hover:bg-white/60 flex items-center justify-center text-slate-500"
          >
            <X className="w-4 h-4" />
          </button>
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-2xl flex items-center justify-center shadow-sm" style={{ backgroundColor: '#6C3D8E15', border: '2px solid #6C3D8E' }}>
              <Smartphone className="w-6 h-6" style={{ color: '#6C3D8E' }} strokeWidth={2.2} />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-base font-bold text-slate-900">Credencial Digital Tysta</h3>
              <p className="text-[11px] text-slate-600 mt-0.5">Pase Digital de identidad y seguridad inteligente.</p>
            </div>
          </div>
        </div>

        {/* Body */}
        <div className="px-5 py-5">
          <p className="text-[10px] font-bold uppercase tracking-wider text-slate-400 mb-3">Descargar la APP</p>
          <div className="grid grid-cols-1 gap-2.5">
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="app-store-link"
              className="flex items-center gap-3 rounded-xl border-2 border-slate-900 bg-slate-900 hover:bg-slate-800 text-white p-3 transition-all hover:scale-[1.01]"
            >
              <Apple className="w-7 h-7 shrink-0" strokeWidth={1.8} />
              <div className="flex-1 min-w-0">
                <p className="text-[10px] uppercase tracking-wider opacity-70">Disponible en</p>
                <p className="text-sm font-bold">App Store</p>
              </div>
              <ExternalLink className="w-4 h-4 opacity-70 shrink-0" />
            </a>
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="play-store-link"
              className="flex items-center gap-3 rounded-xl border-2 border-emerald-700 bg-emerald-700 hover:bg-emerald-800 text-white p-3 transition-all hover:scale-[1.01]"
            >
              <Download className="w-7 h-7 shrink-0" strokeWidth={1.8} />
              <div className="flex-1 min-w-0">
                <p className="text-[10px] uppercase tracking-wider opacity-80">Consíguela en</p>
                <p className="text-sm font-bold">Google Play</p>
              </div>
              <ExternalLink className="w-4 h-4 opacity-80 shrink-0" />
            </a>
          </div>
          <p className="text-[10px] text-slate-400 mt-3 text-center">
            Si no aparece, búscala como <span className="font-semibold text-slate-600">Credencial Digital Tysta</span>.
          </p>
        </div>
      </div>
    </div>
  );
}
